import React, { lazy, Suspense } from "react";
import Herosection from "../components/Herosection";
import TextCarosul from "../components/TextCarosul";
import FAQs from "../components/FAQs";
import LinksTab from "../components/LinksTab";
import ClientRows from "../components/ClientRows";
import APIGrid from "../components/APIGrid";
import BenefitsSection from "../components/BenefitsSection";
import Footer from "../components/Footer";
const ProductUsageView = lazy(() => import("../components/ProductUsageView"));
const Testimonials = lazy(() => import("../components/Testimonials"));

function Home() {
  return (
    <>
      <Herosection />
      <ClientRows />
      <APIGrid />
      <Suspense>
        <ProductUsageView />
      </Suspense>
      <BenefitsSection />
      {/* <ProductAction /> */}
      <Suspense>
        <Testimonials />
      </Suspense>
      <FAQs />
      <TextCarosul />
      <div className="responsive-links-tab">
        <LinksTab />
      </div>
      <Footer />
    </>
  );
}

export default React.memo(Home);
